// AcidWashCard.jsx
import React, { useState } from "react";
import {
  Card,
  Box,
  Typography,
  IconButton,
  Paper,
  Button,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

import CloseIcon from "@mui/icons-material/Close";
/* import SettingsIcon from "@mui/icons-material/Settings";
import ScienceIcon from "@mui/icons-material/Science";
import TextureIcon from "@mui/icons-material/Texture";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import InventoryIcon from "@mui/icons-material/Inventory";
import SellIcon from "@mui/icons-material/Sell"; */
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import Matrix6 from "../../img/logos/Matrix6.png";
import AcidWashTurkey1 from "../../img/Conocimiento/AcidWashTurkey1.png";
import AcidWashTurkey2 from "../../img/Conocimiento/AcidWashTurkey2.png";
import AcidWashTurkey3 from "../../img/Conocimiento/AcidWashTurkey3.png";
import AcidWashTurkey4 from "../../img/Conocimiento/AcidWashTurkey4.png";

import { useTranslation } from "react-i18next";

import jsPDF from "jspdf";

const AcidWashCardTurkey = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();

  const handleToggle = () => setOpen((prev) => !prev);

  const handleDownloadPDF = async () => {
    const doc = new jsPDF({
      unit: "pt",
      format: "a4",
    });

    // -------------------------------------------
    // 1️⃣ Registrar fuentes con soporte chino
    // -------------------------------------------
    /*     doc.addFileToVFS("SourceHan-Regular.ttf", SHS_Regular);
    doc.addFont("SourceHan-Regular.ttf", "SHS", "normal");

    doc.addFileToVFS("SourceHan-Bold.ttf", SHS_Bold);
    doc.addFont("SourceHan-Bold.ttf", "SHS", "bold");

    doc.setFont("SHS"); // Fuente por defecto */

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const marginLeft = 40;
    const maxWidth = 520;
    let y = 90;

    // -------------------------------------------
    // 2️⃣ Loader correcto (con import local)
    // -------------------------------------------
    const loadImage = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.src = src;
      });

    const logo = await loadImage(Matrix6);

    const photos = [
      await loadImage(AcidWashTurkey1),
      await loadImage(AcidWashTurkey2),
      await loadImage(AcidWashTurkey3),
      await loadImage(AcidWashTurkey4),
    ];

    // -------------------------------------------
    // 3️⃣ Header / Footer
    // -------------------------------------------
    const addHeader = () => {
      doc.addImage(logo, "PNG", marginLeft, 20, 60, 60);
      doc.setFont("SHS", "bold");
      doc.setFontSize(16);
      doc.text(t("acidWashTurkey.title"), marginLeft + 70, 55);
      y = 100;
    };

    const addFooter = (pageNumber, totalPages) => {
      doc.setFont("SHS");
      doc.setFontSize(10);
      doc.text(
        `Page ${pageNumber} of ${totalPages}`,
        pageWidth - 100,
        pageHeight - 30,
      );
    };

    // -------------------------------------------
    // 4️⃣ Paragraph writer (chino OK)
    // -------------------------------------------
    const addParagraph = (text) => {
      doc.setFont("SHS");
      doc.setFontSize(12);

      const lines = doc.splitTextToSize(text, maxWidth);

      lines.forEach((line) => {
        if (y > pageHeight - 80) {
          doc.addPage();
          y = 90;
          addHeader();
        }
        doc.text(line, marginLeft, y);
        y += 20;
      });

      y += 10;
    };

    // -------------------------------------------
    // 5️⃣ Image writer
    // -------------------------------------------
    const addImageBlock = (img) => {
      const imgW = 450;
      const ratio = imgW / img.width;
      const imgH = img.height * ratio;

      if (y + imgH > pageHeight - 80) {
        doc.addPage();
        y = 90;
        addHeader();
      }

      doc.addImage(img, "PNG", marginLeft, y, imgW, imgH);
      y += imgH + 20;
    };

    // -------------------------------------------
    // 6️⃣ Generate content
    // -------------------------------------------
    addHeader();

    const paragraphs = t("acidWashTurkey.body", { returnObjects: true });

    paragraphs.forEach((p) => addParagraph(p));

    photos.forEach((photo) => addImageBlock(photo));

    // FOOTERS
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      addFooter(i, totalPages);
    }

    doc.save("Turkey_AcidWash_Report.pdf");
  };

  const closedCardSx = {
    p: 3,
    height: "9em",
    borderRadius: 3,
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: `1px solid ${alpha(theme.palette.info.main, 0.14)}`,
    background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.06)} 0%, ${alpha(
      theme.palette.common.white,
      0.98,
    )} 100%)`,
    boxShadow: `0 8px 22px ${alpha(theme.palette.common.black, 0.07)}`,
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: `0 14px 32px ${alpha(theme.palette.info.main, 0.16)}`,
    },
  };

  return (
    <Box sx={{ position: "relative" }}>
      {/* CARD CERRADA */}
      {!open && (
        <Card onClick={handleToggle} elevation={0} sx={closedCardSx}>
          <Box
            component="img"
            src={Matrix6}
            alt="Matrix Logo"
            sx={{ width: 40, height: 40, mr: 2 }}
          />
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ fontSize: { xs: "0.9rem", sm: "1.1rem" }, lineHeight: 1.3 }}
          >
            {t("acidWashTurkey.title")}
          </Typography>
          <LocalShippingIcon sx={{ color: theme.palette.info.main, ml: 1 }} />
        </Card>
      )}

      {/* CARD ABIERTA COMO MODAL */}
      {open && (
        <Card
          elevation={0}
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", sm: "85vw", md: "75vw" },
            maxHeight: "90vh",
            overflowY: "auto",
            zIndex: 2000,
            borderRadius: 4,
            border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
            boxShadow: `0 24px 64px ${alpha(theme.palette.common.black, 0.22)}`,
            background: "#eef2f7",
            p: 0,
          }}
        >
          {/* HEADER */}
          <Paper
            elevation={0}
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              px: { xs: 2, md: 3 },
              py: 1.75,
              background: `linear-gradient(135deg, ${alpha(theme.palette.info.main, 0.1)} 0%, ${alpha(
                theme.palette.common.white,
                0.94,
              )} 72%)`,
              borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
              backdropFilter: "blur(14px)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
              <Box
                component="img"
                src={Matrix6}
                alt="Matrix Logo"
                sx={{ width: 42, height: 42, flexShrink: 0 }}
              />
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="overline"
                  sx={{
                    display: "block",
                    fontWeight: 800,
                    letterSpacing: 0.8,
                    lineHeight: 1,
                    color: alpha(theme.palette.info.main, 0.7),
                    fontSize: "0.62rem",
                  }}
                >
                  NML · Conocimiento
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 900,
                    lineHeight: 1.2,
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                  }}
                >
                  {t("acidWashTurkey.title")}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Button
                variant="outlined"
                startIcon={<PictureAsPdfIcon />}
                onClick={handleDownloadPDF}
              >
                {t("acidWashTurkey.downloadPDF")}
              </Button>

              <IconButton
                onClick={handleToggle}
                size="small"
                sx={{
                  bgcolor: alpha(theme.palette.grey[500], 0.1),
                  "&:hover": { bgcolor: alpha(theme.palette.grey[500], 0.18) },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Paper>

          {/* CONTENIDO */}
          <Box sx={{ p: { xs: 2, md: 4 } }}>
            {t("acidWashTurkey.body", { returnObjects: true }).map((p, i) => (
              <Typography key={i} paragraph>
                {p}
              </Typography>
            ))}
          </Box>
          <Box sx={{ mt: 2, px: { xs: 2, md: 4 } }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              {t("acidWashTurkey.photosTitle", "Reference Photos")}
            </Typography>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Box component="img" src={AcidWashTurkey1} />
              <Box component="img" src={AcidWashTurkey2} />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box component="img" src={AcidWashTurkey3} />
              <Box component="img" src={AcidWashTurkey4} />
            </Box>
          </Box>
        </Card>
      )}
    </Box>
  );
};

export default AcidWashCardTurkey;
